import React from 'react'
import {Theme} from '@mui/material'
import {createTheme, useTheme, ThemeProvider} from '@mui/material/styles'
import {deepmerge} from '@mui/utils'

interface BreakpointValues {
    xs?: number
    sm?: number
    md?: number
    lg?: number
    xl?: number
}

export function useCustomBreakpoints(breakpoints: BreakpointValues): Theme {
    const oldTheme = useTheme()

    return React.useMemo(() => {
        return createTheme(
            deepmerge(oldTheme, {
                breakpoints: {
                    values: {
                        xs: breakpoints.xs || 0,
                        sm: breakpoints.sm || 600,
                        md: breakpoints.md || 960,
                        lg: breakpoints.lg || 1280,
                        xl: breakpoints.xl || 1920
                    }
                }
            })
        )
    }, [oldTheme, breakpoints])
}

interface CustomBreakpointsProps {
    children?: React.ReactNode
    breakpoints: BreakpointValues
}

export function CustomBreakpoints(props: CustomBreakpointsProps) {
    const themeWithModifiedBreakpoints = useCustomBreakpoints(props.breakpoints)

    return <ThemeProvider theme={themeWithModifiedBreakpoints}>{props.children}</ThemeProvider>
}
